import { render, staticRenderFns } from "./EditOtherInfo.vue?vue&type=template&id=3d85b3e6&scoped=true"
import script from "./EditOtherInfo.vue?vue&type=script&lang=js"
export * from "./EditOtherInfo.vue?vue&type=script&lang=js"
import style0 from "./EditOtherInfo.vue?vue&type=style&index=0&id=3d85b3e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d85b3e6",
  null
  
)

export default component.exports